import React, { useEffect, useRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { checkInTicket } from "../../../../redux/features/adminEventsSlice";
import QRCodeScanner from "../QRCodeScanner";

const ScanTicketsModal = ({
  open,
  event,
  sessionId,
  handleClose,
  tickets,
  handleEditChange,
}) => {
  const ticketsRef = useRef(tickets);
  useEffect(() => {
    ticketsRef.current = tickets;
  }, [tickets]);
  const dispatch = useDispatch();
  const { id: eventId } = event || {};
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      aria-describedby="alert-dialog-description"
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Scanning QR Codes
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <QRCodeScanner
          sessionId={sessionId}
          event={event}
          tickets={tickets}
          handleEditChange={handleEditChange}
          handleClose={handleClose}
          handleCheckInClick={async (ticket, checkedIn) => {
            const { id: ticketId } = ticket;
            await dispatch(
              checkInTicket({
                eventId,
                sessionId,
                ticketId,
                checkedIn,
              }),
            );
          }}
          handleScanId={(ticketId) => {
            const ticket = ticketsRef.current.find(({ id }) => id === ticketId);
            const { checkIn, sessionCheckIns } = ticket || {};
            if (Boolean(ticket) && !ticket.cancellation) {
              const checkedIn = sessionId
                ? (sessionCheckIns || {})[sessionId]
                : Boolean(checkIn);
              if (checkedIn) {
                return { ticketId, error: "already checked in" };
              } else {
                dispatch(
                  checkInTicket({
                    eventId,
                    sessionId,
                    ticketId,
                    checkedIn: true,
                  }),
                );
                return {
                  ticketId,
                };
              }
            } else {
              return { error: "ticket not found" };
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ScanTicketsModal;
